<template lang="pug">
svg(xmlns="http://www.w3.org/2000/svg" viewBox="0 0 26 26")
	path(d="M8.5 12.7L11.871 16L18 10" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round")
</template>

<script>

import Vivus from 'vivus'

export default {
	data() {
		return {
			data: null,
			inst: null
		}
	},

	mounted() {
		this.inst = new Vivus(this.$el, {type: "oneByOne", duration: 30, delay: 15},() => {});
		this.inst.play();
	}
}

</script>